module.exports = __webpack_public_path__ + "static/img/wuliuziyuan.03fef3a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/industryCenter/wuliuziyuan.png
// module id = 81kN
// module chunks = 44